import React from "react";

const Glucose = () => {
  return (
    <svg
    width="21"
    height="19"
     fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 960 960"
    id="vector">
    <path
        id="path"
        d="M 539 880 Q 511 880 486.5 868 Q 462 856 445 834 L 227 557 L 246 537 Q 266 516 294 512 Q 322 508 346 523 L 420 568 L 420 160 Q 420 143 431.5 131.5 Q 443 120 460 120 Q 477 120 489 131.5 Q 501 143 501 160 L 501 712 L 404 652 L 508 785 Q 514 793 522 796.5 Q 530 800 539 800 L 760 800 Q 793 800 816.5 776.5 Q 840 753 840 720 L 840 440 Q 840 423 851.5 411.5 Q 863 400 880 400 Q 897 400 908.5 411.5 Q 920 423 920 440 L 920 720 Q 920 786 873 833 Q 826 880 760 880 L 539 880 Z M 560 520 L 560 320 Q 560 303 571.5 291.5 Q 583 280 600 280 Q 617 280 628.5 291.5 Q 640 303 640 320 L 640 520 L 560 520 Z M 700 520 L 700 360 Q 700 343 711.5 331.5 Q 723 320 740 320 Q 757 320 768.5 331.5 Q 780 343 780 360 L 780 520 L 700 520 Z M 180 400 Q 122 400 81 360 Q 40 320 40 262 Q 40 220 65 186.5 Q 90 153 117 121 L 180 49 L 243 122 Q 270 154 295 187 Q 320 220 320 262 Q 320 320 279 360 Q 238 400 180 400 Z M 180 320 Q 205 320 222.5 303 Q 240 286 240 262 Q 240 235 221.5 215.5 Q 203 196 185 176 L 180 171 L 175 176 Q 157 196 138.5 215.5 Q 120 235 120 262 Q 120 286 137.5 303 Q 155 320 180 320 Z M 650 640 Z M 180 245 Z"
        fill="#40a2e3"/>
</svg>

  );
};

export default Glucose;